export default [
  {
    path: '/',
    redirect: '/home',
    component: () => import('../layout/Dashboardlayout.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../components/pages/Dashboard.vue'),
        meta: {
          restricted: 'dashboard:read'
        }
      },
      {
        path: `/dashboard-analytics`,
        name: `dashboard-analytics`,
        component: () => import(`../components/pages/DashboardAnalytics.vue`),
        meta: {
          restricted: 'dashboard:read'
        }
      },
      {
        path: `/tracking`,
        name: `tracking`,
        props: true,
        component: () => import(`../components/pages/Tracking.vue`),
        meta: {
          restricted: 'tracking:read'
        },
        children: [
          {
            path: ':id([0-9a-fA-F]{7,24})',
            name: 'track-route',
            props: true,
            children: [
              {
                path: 'history',
                name: 'route-history',
                props: true
              },
              {
                path: 'commands',
                name: 'tech-commands',
                props: true
              }
            ]
          }
        ]
      },
      {
        path: `/tracking/dashboards`,
        name: `tracking-dashs`,
        component: () => import(`../components/pages/NewTrackingDashs`),
        meta: {
          restricted: 'tracking:read'
        }
      },
      {
        path: `/tracking/fences`,
        name: `tracking-fences`,
        component: () => import(`../components/pages/TrackingFences`),
        meta: {
          restricted: 'tracking:read'
        }
      },
      {
        path: `/tracking/gerencial`,
        name: `tracking-gerencial`,
        component: () => import(`../components/pages/TrackingManagerial`),
        meta: {
          restricted: 'tracking:read'
        }
      },
      {
        path: `/tracking/estrategico`,
        name: `tracking-strategic`,
        component: () => import(`../components/pages/StrategicMap`),
        meta: {
          restricted: 'tracking:strategic'
        }
      },
      {
        path: `/mro-carriers`,
        name: `mro-carriers`,
        component: () => import(`../components/pages/MroCarriers.vue`),
        meta: {
          restricted: 'admin:mro:strict'
        },
        children: [
          {
            path: 'edit/:id([0-9a-fA-F]{24})',
            name: 'edit-mro-carrier',
            component: () => import('../components/pages/MroCarrierEdit.vue')
          }
        ]
      },
      {
        path: `/mro/dashboard`,
        name: `freightquote`,
        component: () => import(`../components/pages/FreightQuote.vue`),
        meta: {
          restricted: 'freightquote:read'
        }
      },
      {
        path: `/mro/quotes`,
        name: `mro-quotes`,
        component: () => import(`../components/pages/MroQuotes.vue`),
        meta: {
          restricted: 'freightquote:read'
        }
      },
      {
        path: `/maptest`,
        name: `maptest`,
        component: () => import(`../components/pages/Maptest.vue`),
        meta: {
          restricted: 'tracking:read:strict'
        }
      },
      {
        path: `/mapplay`,
        name: `mapplay`,
        component: () => import(`../components/pages/MapPlay.vue`),
        meta: {
          restricted: 'tracking:read:strict'
        }
      },
      {
        path: `/yard/check-in-out`,
        name: `yard`,
        component: () => import(`../components/pages/Courtyard.vue`),
        meta: {
          restricted: 'yard:check-in-out'
        }
      },
      {
        path: `/criarveiculo`,
        name: `newVehicle`,
        component: () => import(`../components/pages/VehicleCreate.vue`)
      },
      {
        path: '/viagens',
        name: 'viagens',
        component: () => import('../components/pages/Offers/index.vue'),
        meta: {
          restricted: 'offer:active'
        }
      },
      {
        path: '/historico-de-ofertas',
        name: 'historicodeofertas',
        component: () => import('../components/pages/OffersHistoric.vue'),
        meta: {
          restricted: 'offer:history'
        }
      },
      {
        path: '/tickets',
        name: 'chathistoric',
        component: () => import('../components/pages/ChatHistoric.vue'),
        meta: {
          restricted: 'admin:tickets:strict'
        }
      },
      {
        path: '/radar',
        name: 'radar',
        component: () => import('../components/pages/Radar.vue'),
        meta: {
          restricted: 'radar:read'
        }
      },
      {
        path: '/trap',
        name: 'trap',
        component: () => import('../components/pages/Trap.vue'),
        meta: {
          restricted: 'radar:read'
        }
      },
      {
        path: '/lista-de-cadastro',
        name: 'priority-drivers',
        component: () => import('../components/pages/DriversPriority.vue'),
        meta: {
          restricted: 'registration:priority'
        }
      },
      {
        path: '/motoristas',
        name: 'motoristas',
        component: () => import('../components/pages/Drivers.vue'),
        meta: {
          restricted: 'registration:driver'
        }
      },
      {
        path: '/proprietarios',
        name: 'proprietarios',
        component: () => import('../components/pages/Owners.vue'),
        meta: {
          restricted: 'registration:provider'
        }
      },
      {
        path: '/proprietarios/criar',
        name: 'criarproprietario',
        component: () => import('../components/pages/CarriersCreate.vue'),
        meta: {
          restricted: 'registration:provider'
        }
      },
      {
        path: '/veiculos',
        name: 'veiculos',
        component: () => import('../components/pages/Vehicles.vue'),
        meta: {
          restricted: 'registration:vehicle'
        }
      },
      {
        path: '/blacklist',
        name: 'blacklist',
        component: () => import('../components/pages/Blacklist/Index.vue'),
        meta: {
          restricted: 'registration:blacklist'
        }
      },
      {
        path: '/resgate',
        name: 'resgate',
        component: () => import('../components/pages/Resgate.vue'),
        meta: {
          restricted: 'fidelity:prize'
        }
      },
      {
        path: '/ranking',
        name: 'ranking',
        component: () => import('../components/pages/Ranking.vue'),
        meta: {
          restricted: 'fidelity:ranking'
        }
      },
      {
        path: '/criar-viagem',
        name: 'criar-viagem',
        component: () => import('../components/pages/OfferCreate.vue'),
        meta: {
          restricted: 'offer:active'
        }
      },
      {
        path: '/editar-proprietario/:id',
        name: 'editar-proprietario',
        component: () => import('../components/pages/CarrierEditor.vue'),
        meta: {
          restricted: 'registration:provider'
        }
      },
      {
        path: '/editar-veiculo/:id',
        name: 'editar-veiculo',
        component: () => import('../components/pages/VehicleEditor.vue'),
        meta: {
          restricted: 'registration:vehicle'
        }
      },
      {
        path: '/editar-viagem/:id',
        name: 'editar-viagem',
        component: () => import('../components/pages/Editarviagem.vue'),
        meta: {
          restricted: 'offer:active'
        }
      },
      {
        path: '/tipo-veiculos',
        name: 'tipo-veiculos',
        component: () => import('../components/pages/TypeVehicle.vue'),
        meta: {
          restricted: 'admin:typevehicle:strict'
        },
        children: [
          {
            path: ':id([0-9a-fA-F]{24})',
            name: 'tipo-veiculo',
            component: () => import('../components/pages/TypeVehicleView.vue')
          }
        ]
      },
      {
        path: '/tipo-veiculos/criar',
        name: 'tipo-veiculos-criar',
        component: () => import('../components/pages/TypeVehicleCreate.vue'),
        meta: {
          restricted: 'admin:typevehicle:strict'
        }
      },
      {
        path: '/transportadoras',
        name: 'transportadoras',
        component: () =>
          import('../components/pages/ExternalCarrier/ExternalCarriers.vue'),
        meta: {
          restricted: 'admin:branch:strict'
        }
      },
      {
        path: '/embarcadores',
        name: 'embarcadores',
        component: () => import('../components/pages/Shipper/Shippers.vue'),
        meta: {
          restricted: 'admin:branch:strict'
        }
      },
      {
        path: '/filiais',
        name: 'filiais',
        component: () => import('../components/pages/Branches.vue'),
        meta: {
          restricted: 'admin:branch:strict'
        }
      },
      {
        path: '/new-user',
        name: 'new-user',
        component: () => import('../components/pages/Users/NewUser.vue'),
        meta: {
          restricted: 'admin:user:strict'
        }
      },
      {
        path: '/users',
        name: 'users',
        component: () => import('../components/pages/Users/Users.vue'),
        meta: {
          restricted: 'admin:user:strict'
        }
      },
      {
        path: '/users/:id/edit',
        name: 'edit-user',
        component: () => import('../components/pages/Users/UserEdit.vue'),
        meta: {
          restricted: 'admin:user:strict'
        }
      },
      {
        path: '/users-sftp',
        name: 'users-sftp',
        component: () => import('../components/pages/UsersSFTP/NewUser'),
        meta: {
          restricted: 'admin:users-sftp:strict'
        }
      },
      
      {
        path: '/permissions',
        name: 'permissions',
        component: () => import('../components/pages/Roles.vue'),
        meta: {
          restricted: 'admin:permission:strict'
        }
      },
      {
        path: '/permissions/group',
        name: 'manage-group',
        component: () => import('../components/pages/ManageGroup.vue'),
        meta: {
          restricted: 'admin:permission:strict'
        },
        children: [
          {
            path: ':id',
            name: 'edit-group',
            meta: {
              restricted: 'admin:permission:strict'
            }
          }
        ]
      },
      {
        path: '/permissions/role',
        name: 'manage-role',
        component: () => import('../components/pages/ManageRole.vue'),
        meta: {
          restricted: 'admin:permission:strict'
        },
        children: [
          {
            path: ':id',
            name: 'edit-role',
            meta: {
              restricted: 'admin:permission:strict'
            }
          }
        ]
      },
      {
        path: '/permissions/policy',
        name: 'manage-policy',
        component: () => import('../components/pages/ManagePolicy.vue'),
        meta: {
          restricted: 'admin:permission:strict'
        },
        children: [
          {
            path: ':id',
            name: 'edit-policy',
            meta: {
              restricted: 'admin:permission:strict'
            }
          }
        ]
      },
      {
        path: '/yard/checklist',
        component: () => import(`../components/pages/Yard/Checklist/Index.vue`),
        children: [
          {
            path: '',
            component: () =>
              import('../components/pages/Yard/Checklist/View.vue'),
            meta: {
              restricted: `yard:checklists`
            }
          },
          {
            path: 'new',
            component: () =>
              import('../components/pages/Yard/Checklist/FormV2.vue'),
            meta: {
              restricted: `yard:checklist`
            }
          }
        ]
      },
      {
        path: '/settings',
        name: 'settings',
        component: () => import('../components/pages/Settings/Index.vue'),
        meta: {
          restricted: 'admin:user:strict'
        }
      },
      {
        path: '/calculate-toll',
        name: 'calculate-toll',
        component: () => import('../components/pages/CalculateToll/Index.vue'),
        meta: {
          restricted: 'dashboard:read'
        }
      },
      {
        path: '/update-pis',
        name: 'update-pis',
        component: () => import('../components/pages/UpdatePis/Index.vue'),
        meta: {
          restricted: 'dashboard:read'
        }
      },
      {
        path: '/log-pis',
        name: 'log-pis',
        component: () => import('../components/pages/UpdatePis/Log.vue'),
        meta: {
          restricted: 'admin:read'
        }
      },
      {
        path: '/log-offer',
        name: 'log-offer',
        component: () => import('../components/pages/LogOffers.vue'),
        meta: {
          restricted: 'admin:read'
        }
      },
      {
        path: '/log-tolls',
        name: 'log-tolls',
        component: () =>
          import('../components/pages/CalculateToll/LogTolls.vue'),
        meta: {
          restricted: 'dashboard:read'
        }
      },
      {
        path: '/report-grs',
        name: 'report-grs',
        component: () => import('../components/pages/GR/Index.vue'),
        meta: {
          restricted: 'dashboard:read'
        }
      },
      {
        path: '/report-cpf-pis',
        name: 'report-cpf-pis',
        component: () => import('../components/pages/CpfPis.vue'),
        meta: {
          restricted: 'dashboard:read'
        }
      },
      /* teste mapbox
      {
        path: '/map-points',
        name: 'map-points',
        component: () => import('../components/pages/MapBox.vue'),
        meta: {
          restricted: 'dashboard:read'
        }
      },*/
      {
        path: '/dashboard/drivers-in-panic',
        name: 'drivers-in-panic',
        component: () => import(`../components/pages/DriversInPanic`),
        meta: {
          restricted: 'dashboard:read'
        }
      },
      {
        path: '/dashboard/drivers-near',
        name: 'drivers-near',
        component: () => import(`../components/pages/DriversNear`),
        meta: {
          restricted: 'dashboard:read'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    redirect: '',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/reset_password',
    name: 'reset-password',
    redirect: '',
    component: () => import('../views/ResetPassword.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

export const fallbacks = [
  '/home',
  '/viagens',
  '/motoristas',
  '/yard/checklist',
  '/yard/checklist/new'
]
